import React from 'react';
import { Box, IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import TypeBadge from 'features/feedback/shared/TypeBadge';
import StatusChip from 'features/feedback/shared/StatusChip';
import { FeedbackTO, BUG_AREA_LABEL, SEVERITY_LABEL } from 'features/feedback/shared/feedback.types';

const meta = (f: FeedbackTO): string => {
  if (f.type === 'BUG') return [f.bugArea && BUG_AREA_LABEL[f.bugArea], f.severity && SEVERITY_LABEL[f.severity]].filter(Boolean).join(' · ');
  if (f.type === 'IDEA') return `публічна · ${f.voteCount ?? 0} голосів`;
  if (f.type === 'REVIEW' && f.rating) return `оцінка ${f.rating} / 5`;
  return '';
};

const SubmissionRow: React.FC<{ item: FeedbackTO; onDelete: (id: number) => void }> = ({ item, onDelete }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: '12px 14px', border: '1px solid #E7E7E7', borderRadius: '12px' }}>
    <TypeBadge type={item.type} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Box sx={{ fontSize: 14.5, fontWeight: 600 }}>{item.title}</Box>
      <Box sx={{ fontSize: 12.5, color: '#7A7F88' }}>{meta(item)}</Box>
    </Box>
    <StatusChip status={item.status} />
    <IconButton size="small" aria-label="Видалити" onClick={() => onDelete(item.id)}>
      <DeleteOutlineIcon fontSize="small" />
    </IconButton>
  </Box>
);

export default SubmissionRow;
